import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import SliderThumbTexture from "@/assets/textures/slider-thumb.svg?react"

import { cn } from "@/shared/lib/utils"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary">
      <SliderPrimitive.Range className="absolute h-full bg-green-100" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="relative">
      <SliderThumbTexture className="absolute left-0 top-1/2 -translate-x-4 -translate-y-1/2 drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]" />
    </SliderPrimitive.Thumb>
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
